import {
  LEGEND_FONT_FAMILY,
  LEGEND_FONT_SIZE,
  LEGEND_LABEL_START_X,
  LEGEND_LABEL_VALUE_GAP,
  LEGEND_VALUE_END_X,
} from "../LegendBox";
import { truncateLabelToFit } from "../truncateLabelToFit";
import type { TruncateLegendItems } from "./types";

// Measured at scale=1: dimensions, font and text widths all scale linearly, so the fit is scale-invariant.
export const truncateLegendItems: TruncateLegendItems = ({
  items,
  context,
}) => {
  context.save();
  context.font = `${LEGEND_FONT_SIZE}px ${LEGEND_FONT_FAMILY}`;
  const truncatedItems = items.map((item) => {
    const valueWidth = context.measureText(item.value).width;
    const availableLabelWidth =
      LEGEND_VALUE_END_X -
      LEGEND_LABEL_START_X -
      valueWidth -
      LEGEND_LABEL_VALUE_GAP;
    return {
      ...item,
      label: truncateLabelToFit({
        label: item.label,
        availableWidth: availableLabelWidth,
        ctx: context,
      }),
    };
  });
  context.restore();
  return truncatedItems;
};
